import { render } from "./header-category.vue?vue&type=template&id=7dc769c8"
import script from "./header-category.vue?vue&type=script&lang=js"
export * from "./header-category.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__